import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
//import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

declare const Shapes: any;
declare const Rellax: any;
declare const document: any;
declare const window: any;
const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  mySubscription: any;
  RellaxInstance: any;
  
  //location: Location;
  constructor(
    private router: Router,
    private el:ElementRef
    /*private location: Location*/
  ) { 
    // Fix reload
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
      
    router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = router.parseUrl(router.url);
        if (tree.fragment) {
          const element = document.querySelector("#" + tree.fragment);
          if (element && typeof element?.scrollIntoView == 'function') { element.scrollIntoView(true); }
        }
      }
    });
  }
  
  reloadHome(): boolean {
    void this.router.navigate(['/home']);
    return false;
  }
  
  firstSection(): boolean { 
    this.el.nativeElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    return false;
  }
  
  scroll(to: number, target: number){
    let wrapper = this.el.nativeElement;
    let duration = 1200;
    let start = null;
    
    function easeInCubic(t: number) { 
      return t*t*t;
    }
    
    function scrollFn(timestamp){
      if (start === null) start = timestamp;
      let progress: number; 
      let nextScroll = wrapper.scrollTop;
      
      if(nextScroll < target){
        
        progress = timestamp - start;
        let nextScroll = to;
        
        if(progress < duration){
          let progressPercent = progress/duration*100;
          let progressDecimalNumber = progressPercent / 100;
          nextScroll+= target * (progressDecimalNumber*easeInCubic(progressDecimalNumber));
          requestAnimationFrame(scrollFn);
        }else{
          nextScroll = target;
        }
        
        wrapper.scrollTop = nextScroll;
      
      }else{
        
      }
    }
    
    requestAnimationFrame(scrollFn);
  };
  
  nextSection(section: number): boolean {    
    let nextSection = this.el.nativeElement.querySelector('[data-section="'+section+'"]');
    let screenCenter = this.el.nativeElement.getBoundingClientRect().height / 2; 
    let nextSectionTop = nextSection ? nextSection.getBoundingClientRect().top : 0;
    this.scroll(this.el.nativeElement.scrollTop,this.el.nativeElement.scrollTop+nextSectionTop);
    return false;
  }
  
  drawBackground(): void {
    
    let AngularEl = this.el.nativeElement;
    new Shapes(this.el.nativeElement.querySelector("#section1"),{ 
    count: 250,
    img: ['shape_0_1.svg','shape_0_2.svg','shape_0_3.svg','shape_0_8.svg','shape_1_1.svg','shape_1_2.svg', 'shape_1_3.svg','shape_1_8.svg','shape_2_1.svg','shape_2_2.svg','shape_2_3.svg','shape_2_8.svg','shape_3_1.svg','shape_3_2.svg','shape_3_3.svg','shape_3_8.svg'],
    top: {
      min: -17,
      max: 91.5
    }, left: {
      min: -17,
      max: 91.5
    }, rellax: true },function(){
      
      this.RellaxInstance = new Rellax(AngularEl.querySelector('#section1').querySelector('.rellax'),{
        wrapper: AngularEl
      });
      this.RellaxInstance.elems = AngularEl.querySelector('#section1').querySelectorAll('.rellax'); /* Rellax force array of nodes */
      this.RellaxInstance.refresh();
      
    });

      /*new Shapes(this.el.nativeElement.querySelector("#section1"),{ count: 10, img: ['shape_4_1.svg','shape_4_2.svg','shape_4_3.svg','shape_4_8.svg'], top: {
      min: 85,
      max: 100
    }, left: {
      min: -17,
      max: 117
    }, rellax: false },function(){
      });*/

      /*new Shapes(this.elRef.nativeElement.querySelector("#section2"),{ count: 250, img: ['shape_0_1.svg','shape_0_2.svg','shape_0_3.svg','shape_0_8.svg','shape_1_1.svg','shape_1_2.svg', 'shape_1_3.svg','shape_1_8.svg','shape_2_1.svg','shape_2_2.svg','shape_2_3.svg','shape_2_8.svg','shape_3_1.svg','shape_3_2.svg','shape_3_3.svg','shape_3_8.svg'], top: {
            min: -17,
            max: 91.5
          }, left: {
            min: -17,
            max: 91.5
          }, rellax: false },function(){
        //new Rellax('.rellax');
      });*/
  }

  ngOnInit(): void {
    
    this.drawBackground();
    
  }

  ngOnDestroy() {
    /*document.querySelector("#section1").remove();
    document.querySelector("#section2").remove();*/
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
    if (this.RellaxInstance){
      this.RellaxInstance.destroy();
    }
  }
}